var toggle_section_triggers = document.querySelectorAll( '[data-toggle-section]' );
var toggle_sections = document.querySelectorAll( '.toggle-section' );

toggle_section_triggers.forEach( function( trigger ) {
    var target = document.querySelector( trigger.dataset.toggleSection );
    var group = trigger.dataset.toggleSectionGroup;
    
    trigger.addEventListener( 'click', function( e ) {
        e.preventDefault();
        
        toggle_section_triggers.forEach( function( e ) {
            if ( group == e.dataset.toggleSectionGroup ) {
                e.classList.remove( 'active' );
            }
        } );
        
        toggle_sections.forEach( function( e ) {
            if ( group == e.dataset.toggleSectionGroup ) {
                e.classList.remove( 'active' );
            }
        } );
        
        trigger.classList.add( 'active' );
        target.classList.add( 'active' );
    } );
} );
